import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

import { loadClientRecord } from "@/lib/client-api";
import {
  ClientPdfShell,
  ClientNotAuthenticated,
  ClientNotAvailable,
} from "@/components/client-pdf-shell";

export const Route = createFileRoute("/$tenantSlug/invoice/$invoiceId")({
  component: InvoiceView,
});

function InvoiceView() {
  const { tenantSlug, invoiceId } = Route.useParams();
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["client-invoice", tenantSlug, invoiceId] as const,
    queryFn: () => loadClientRecord(tenantSlug, "invoices", invoiceId),
    retry: false,
  });

  if (isLoading) {
    return (
      <div className="flex-1 grid place-items-center text-sm text-slate-500">
        Loading&hellip;
      </div>
    );
  }
  if (isError) {
    const err = error as (Error & { status?: number }) | undefined;
    if (err?.status === 401) {
      return <ClientNotAuthenticated tenantSlug={tenantSlug} />;
    }
    return <ClientNotAvailable tenantSlug={tenantSlug} message={err?.message} />;
  }
  if (!data) {
    return <ClientNotAvailable tenantSlug={tenantSlug} />;
  }
  return (
    <ClientPdfShell
      tenantSlug={tenantSlug}
      view={data}
      fallbackTitle={`Invoice #${invoiceId}`}
    />
  );
}
